import { render, staticRenderFns } from "./away.vue?vue&type=template&id=26df99bc&"
import script from "./away.vue?vue&type=script&lang=js&"
export * from "./away.vue?vue&type=script&lang=js&"
import style0 from "./away.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports